import React, { useState, useEffect } from "react";
import {
  Users,
  Heart,
  MessageSquare,
  Image as ImageIcon,
} from "lucide-react";
import LoadingCircle from "../../components/Common/LoadingCircle";

const Index = () => {
  const [loading, setLoading] = useState(false);
  const data = { guests: [], families: [], photos: [], wishes: [] }; 

  const stats = {
    totalTamu: 0, totalKeluarga: 0, totalWishes: 0, totalPhotos: 0,
    hadir: 0, pending: 0, tidakHadir: 0,
  };

  const summary = [
    { label: "Total Tamu", value: stats.totalTamu, icon: <Users size={20} />, color: "bg-blue-500" },
    { label: "Keluarga", value: stats.totalKeluarga, icon: <Heart size={20} />, color: "bg-red-500" },
    { label: "Ucapan Doa", value: stats.totalWishes, icon: <MessageSquare size={20} />, color: "bg-amber-500" },
    { label: "Foto Galeri", value: stats.totalPhotos, icon: <ImageIcon size={20} />, color: "bg-stone-800" },
  ];

  useEffect(() => {
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <section id="experience" className="py-20 flex flex-col items-center justify-center min-h-[400px]">
        <LoadingCircle size="lg" />
        <p className="mt-4 text-slate-400 font-mono text-[10px] uppercase tracking-widest animate-pulse">
          Retrieving  Data...
        </p>
      </section>
    );
  }
  

  return (
    <div className="relative min-h-125 space-y-8 font-sans">
       {/* STATS GRID */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            {summary.map((item, i) => (
              <div
                key={i}
                className="bg-white p-5 rounded-3xl border border-stone-100 shadow-sm hover:shadow-md transition-all"
              >
                <div
                  className={`w-10 h-10 ${item.color} text-white rounded-2xl flex items-center justify-center mb-4 shadow-lg shadow-stone-200`}
                >
                  {item.icon}
                </div>
                <p className="text-[10px] font-black text-stone-400 uppercase tracking-widest">
                  {item.label}
                </p>
                <p className="text-2xl font-black text-stone-800 mt-1">
                  {item.value}
                </p>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* RSVP PROGRESS */}
            <div className="lg:col-span-2 bg-white p-6 rounded-[2.5rem] border border-stone-100 shadow-sm">
             
              <div className="space-y-4">
                {[
                  { label: "Hadir", count: stats.hadir, color: "bg-green-500" },
                  {
                    label: "Belum Konfirmasi",
                    count: stats.pending,
                    color: "bg-amber-400",
                  },
                  {
                    label: "Tidak Hadir",
                    count: stats.tidakHadir,
                    color: "bg-red-400",
                  },
                ].map((stat, i) => (
                  <div key={i}>
                    <div className="flex justify-between text-[10px] font-black uppercase mb-1.5 tracking-tighter">
                      <span className="text-stone-500">{stat.label}</span>
                      <span className="text-stone-800">{stat.count} Orang</span>
                    </div>
                    <div className="w-full h-2 bg-stone-100 rounded-full overflow-hidden">
                      <div
                        className={`h-full ${stat.color} transition-all duration-1000`}
                        style={{
                          width: `${(stat.count / (stats.totalTamu || 1)) * 100}%`,
                        }}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* RECENT ACTIVITY */}
            <div className="bg-stone-900 p-6 rounded-[2.5rem] text-white shadow-xl">
             
              <div className="space-y-5">
                {data.wishes.slice(0, 3).map((wish, i) => (
                  <div
                    key={i}
                    className="flex gap-3 border-l-2 border-stone-700 pl-4 py-1"
                  >
                    <div className="flex-1">
                      <p className="text-[11px] font-bold">
                        {wish.sender}{" "}
                        <span className="font-normal text-stone-400 text-[10px]">
                          kirim ucapan
                        </span>
                      </p>
                      <p className="text-[9px] text-stone-500 uppercase mt-1 font-black">
                        {wish.date}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
    </div>
  );
};

export default Index;
